var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew225({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 3,
    y: 3,
    width: 10,
    height: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10,8.16c0-.79-.09-1.73-.08-2.44h0c-.19.66-.42,1.37-.71,2.14l-1,2.74H7.66L6.74,7.91c-.26-.79-.49-1.52-.65-2.19h0C6.06,6.43,6,7.37,6,8.21l-.15,2.42h-.7L5.51,5h.93l1,2.72c.24.7.43,1.32.57,1.9H8c.14-.57.34-1.19.59-1.9L9.6,5h.92l.36,5.63h-.72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew225);
export default __webpack_public_path__ + "static/media/Symbolpack_New_225.a8b20a280d5be0bc8857dfe65be69765.svg";
export { ForwardRef as ReactComponent };